export enum Positions {
  TOP = 'top',
  BOTTOM = 'bottom',
  END = 'end',
  START = 'start',
}
